<form
  [formGroup]="workLocationForm"
  (ngSubmit)="onSubmit()"
  [hasUnsavedData]="workLocationForm"
>
  <button type="submit" hidden="hidden"></button>

  <div class="row mb-2">
    <div class="col-12 col-md-6 mr-auto">
      <div class="form-group">
        <label class="form-title-label" for="name" translate>WORK_LOCATION_LBL_NAME</label>
        <input
          id="name"
          class="form-control form-title"
          type="text"
          formControlName="name"
          checkFormFieldValidity
          [maxLength]="100"
        />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_TYPE</label>
        <div class="col">
          <app-typeahead
            [limitToList]="true"
            [dataType]="DataType.Enum"
            [referenceEndpoint]="'Views/enum/values'"
            [referenceField]="'Comparanoo.Core.Enums.Attendances.WorkLocationType'"
            [dropdownStyle]="DropdownStyle.DropDownList"
            [controlForm]="this.workLocationForm.controls['type']"
            [valueMember]="'value'"
            [displayMember]="'name'"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_SALES_TEAM</label>
        <div class="col">
          <app-typeahead
            [routeEndpoint]="'SalesTeams'"
            [controlForm]="this.workLocationForm.controls['salesTeamId']"
            [displayMember]="'name'"
            [valueMember]="'id'"
            [orderBy]="'name asc'"
            [limitToList]="true"
            [domain]="'active=true'"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="countedAsWork" translate>WORK_LOCATION_LBL_COUNTED_AS_WORK</label>
        <div class="col">
          <input
            id="countedAsWork"
            class="form-control-sm"
            type="checkbox"
            formControlName="countedAsWork"
            checkFormFieldValidity
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label-sm" for="active" translate>WORK_LOCATION_LBL_ACTIVE</label>
        <div class="col">
          <input
            id="active"
            class="form-control-sm"
            type="checkbox"
            formControlName="active"
            checkFormFieldValidity
          />
        </div>
      </div>
    </div>
  </div>
</form>
